module.exports = __webpack_public_path__ + "media/elevadizo/buqueCargadorDerecha-di-ap-92066a82.png";